export default __webpack_public_path__ + "static/media/GenWanMinTW-SB-01.6ec30d5e.woff2";